import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";
import {ProtectRoute} from "../components/ProtectRoute";

// Retailer Layout
const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout")));
// Privacy Policy
const PrivacyPolicy = Loadable(lazy(() => import("../views/importantDocs/privacyPolicy")));
// Terms And Condition
const TermsAndCondition = Loadable(lazy(() => import("../views/importantDocs/termsAndCondition")));
// Retailer Dashboard
const RetailerDashboard = Loadable(lazy(() => import("../views/Retailer/dashboard")));
// Change Password
const ChangesPassword = Loadable(lazy(() => import("../views/Admin/UserManagement/changesPassword")));
// Change TPin
const ChangeTPinWithOld = Loadable(lazy(() => import("../views/Admin/UserManagement/changeTPinWithOld")));
// Complaint List
const ComplaintInternalList = Loadable(lazy(() => import("../views/complaint/complaintList")));
const ComplaintInternalAdd = Loadable(lazy(() => import("../views/complaint/complaintAdd")));
const ComplaintInternalDetails = Loadable(lazy(() => import("../views/complaint/complaintDetails")));
// Bill Avenue Complaint List
const ComplaintListBillAvenue = Loadable(lazy(() => import("../views/complaint/complaintListBillAvenue")));
// OnBoarding KYC
const AddDocumentKyc = Loadable(lazy(() => import("../views/profiles/addDocumentKyc")));
// Profile
const UserProfileHome = Loadable(lazy(() => import("../views/profiles/userProfile/userProfileHome")));
// Self Bank
const SelfBank = Loadable(lazy(() => import("../views/bank/selfBank")));
// AEPS to DMT Transfer
// const AEPSToDMTTransfer = Loadable(lazy(() => import("../views/Retailer/aeps/aepsToDmtTransfer")));
// Wallet to Wallet Transfer
const WalletToWallet = Loadable(lazy(() => import("../views/Retailer/wallet/walletToWallet")));
// API User Development Documents
const DevelopersDocument = Loadable(lazy(() => import("../views/api/apiDevDocuments/developersDocument")));
// PG to main Wallet Transfer
// const PGToMainWallet = Loadable(lazy(() => import("../views/Retailer/wallet/pgToMainWallet")));
// User Balance Request
const BalanceRequestList = Loadable(lazy(() => import("../views/balanceRequest/balanceRequestList")));
const NewBalanceRequest = Loadable(lazy(() => import("../views/balanceRequest/newBalanceRequest")));
// User Services
const BillPayments = Loadable(lazy(() => import("../views/services/billPayments/billPayments")));
const OfflineBillPayments = Loadable(lazy(() => import("../views/services/billPayments/offlineBillPayment")));
const RechargeBill = Loadable(lazy(() => import("../views/services/recharges/recharge")));
const AllPaymentsHome = Loadable(lazy(() => import("../views/services/payments/allPaymentsHome")));
const AEPSHome = Loadable(lazy(() => import("../views/services/aeps/aepsHome")));
const ECollection = Loadable(lazy(() => import("../views/services/eCollection")));
// const UPPaymentsHome = Loadable(lazy(() => import("../views/services/upiPayments/upiPaymentsHome")));
// const PayoutHome = Loadable(lazy(() => import("../views/services/payout/payoutHome")));
// User Reports
const LedgerReport = Loadable(lazy(() => import("../views/Retailer/reports/ledgerReport")));
const MainWalletLedgerReport = Loadable(lazy(() => import("../views/Retailer/reports/mainWalletLedgerReport")));
const PGLedgerReportRetailer = Loadable(lazy(() => import("../views/Retailer/reports/pgLedgerReport")));
const CashoutReport = Loadable(lazy(() => import("../views/Retailer/reports/cashoutReport")));
const AEPSLedgerReport = Loadable(lazy(() => import("../views/Retailer/reports/aepsLedgerReport")));
const MoneyTransferReports = Loadable(lazy(() => import("../views/Retailer/reports/moneyTransferReports")));
const MoneyTransferHoldReport = Loadable(lazy(() => import("../views/Retailer/reports/moneyTransferHoldReport")));
const AEPSTransactionReports = Loadable(lazy(() => import("../views/Retailer/reports/aepsTransactionReports")));
const BillPaymentReport = Loadable(lazy(() => import("../views/Retailer/reports/billPaymentReport")));
const RailBookingReport = Loadable(lazy(() => import("../views/Retailer/reports/railBookingReport")));
const FlightBookingReport = Loadable(lazy(() => import("../views/Retailer/reports/flightBookingReport")));
const PaymentGetwayReport = Loadable(lazy(() => import("../views/Retailer/reports/paymentGetwayReport")));
const OutStandingReport = Loadable(lazy(() => import("../views/Retailer/reports/outStandingReport")));
const TopUpReports = Loadable(lazy(() => import("../views/Retailer/reports/topUpReport")));
const PGSettlementReport = Loadable(lazy(() => import("../views/Retailer/reports/pgSettlementReport")));
const PGPayoutReconciliationReport = Loadable(lazy(() => import("../views/Retailer/reports/pgPayoutReconciliationReport")));
const TransactionStatusReports = Loadable(lazy(() => import("../views/Retailer/reports/txnStatusReports")));

const retailerRouter = {
  path: "/retailer",
  key: 5,
  element: <ProtectRoute Component={FullLayout} />,
  children: [
    // Privacy Policy
    {
      key: 5.1,
      path: "privacyPolicy",
      name: "PrivacyPolicy",
      element: <PrivacyPolicy />,
    },
    // Term and Condition
    {
      key: 5.2,
      path: "termsAndCondition",
      name: "termsAndCondition",
      element: <TermsAndCondition />,
    },
    // Dashboard
    {
      key: 5.3,
      path: "dashboard",
      name: "Dashboard",
      element: <RetailerDashboard />,
    },
    // Onboarding KYC
    {
      key: 5.4,
      path: "addDocumentKyc",
      name: "addDocumentKyc",
      element: <AddDocumentKyc />,
    },
    // User Settings
    {
      path: "settings",
      key: 5.5,
      children: [
        // Change My Password
        {
          path: "changesPassword",
          name: "settings-changesPassword",
          element: <ChangesPassword />,
        },
        // User Profile
        {
          path: "profile",
          name: "settings-profile",
          element: <UserProfileHome />,
        },
        // User Profile
        {
          path: "changesTpin",
          name: "settings-changesTpin",
          element: <ChangeTPinWithOld />,
        },
        // User Complaint List
        {
          path: "complaintList",
          name: "settings-complaintInternalList",
          element: <ComplaintInternalList />,
        },
        {
          path: "addComplaint",
          name: "settings-complaintInternalAdd",
          element: <ComplaintInternalAdd />,
        },
        {
          path: "complaintDetails",
          name: "settings-complaintInternalDetails",
          element: <ComplaintInternalDetails />,
        },
        // User Bill Avenue Complaint List
        {
          path: "billAvenueComplaintList",
          name: "settings-billAvenueComplaintList",
          element: <ComplaintListBillAvenue />,
        },
      ]
    },
    // User Self Bank
    {
      key: 5.6,
      path: "selfBank",
      name: "selfBank",
      element: <SelfBank />,
    },
    // User AEPS to DMT Transfer
    // {
    //   key: 5.8,
    //   path: "aepsWalletToDmt",
    //   name: "aepsWalletToDmt",
    //   element: <AEPSToDMTTransfer />,
    // },
    // User Wallet to Wallet
    {
      key: 5.8,
      path: "walletToWallet",
      name: "walletToWallet",
      element: <WalletToWallet />,
    },
    // API User Development Documents
    {
      key: 5.8,
      path: "developersDocuments",
      name: "developersDocuments",
      element: <DevelopersDocument />,
    },
    // User PG to Main Wallet
    // {
    //   key: 5.10,
    //   path: "pgToMainWallet",
    //   name: "pgToMainWallet",
    //   element: <PGToMainWallet />,
    // },
    // Balance Request
    {
      path: "balanceRequest",
      key: 5.11,
      children: [
        // User Balance Request List
        {
          path: "",
          name: "balanceRequest",
          element: <BalanceRequestList />,
        },
        {
          path: "newBalanceRequest",
          name: "newBalanceRequest",
          element: <NewBalanceRequest />,
        },
      ]
    },
    // Services
    {
      path: "services",
      key: 5.12,
      children: [
        // User Balance Request List
        {
          path: "billPayments",
          name: "billPayments[BBPS OFFLINE(EKO)]",
          element: <OfflineBillPayments />,
        },
        {
          path: "billPayments2",
          name: "billPayments2[BILL PAYMENTS - 2(MULTILINK)]",
          element: <BillPayments />,
        },
        {
          path: "billPayments3",
          name: "billPayments3[BILL PAYMENTS - 3(BILLAVENUE)]",
          element: <BillPayments />,
        },
        {
          path: "licPayments",
          name: "licPayments[LIC PAYMENTS(PAYSPRINT)]",
          element: <BillPayments />,
        },
        {
          path: "lpgGas",
          name: "lpgGas[LPG GAS(PAYSPRINT)]",
          element: <BillPayments />,
        },
        {
          path: "fastag",
          name: "fastag[FASTAG(PAYSPRINT)]",
          element: <BillPayments />,
        },
        {
          path: "offlineBillPay",
          name: "offlineBillPay[OFFLINE BILL PAY(EKO)]",
          element: <OfflineBillPayments />,
        },
        {
          path: "recharge",
          name: "recharge[RECHARGE(AMBIKA)]",
          element: <RechargeBill />,
        },
        {
          path: "mobileRecharge",
          name: "mobileRecharge[MOBILE RECHARGE(PAYSPRINT)]",
          element: <RechargeBill />,
        },
        {
          path: "recharge2",
          name: "recharge2[RECHARGE - 2(MULTILINK)]",
          element: <RechargeBill />,
        },
        {
          path: "dth",
          name: "dth[DTH(AMBIKA)]",
          element: <RechargeBill />,
        },
        {
          path: "dthRecharge",
          name: "dthRecharge[DTH RECHARGE(PAYSPRINT)]",
          element: <RechargeBill />,
        },
        {
          path: "dth2",
          name: "dth2[DTH-2(MULTILINK)]",
          element: <RechargeBill />,
        },
        {
          path: "upiPaymentPayout",
          name: "upiPaymentPayout[UPI PAYMENT PAYOUT(PAY2ALL)]",
          element: <AllPaymentsHome />,
        },
        {
          path: "payout",
          name: "payout([Payout-1(EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "payout2",
          name: "payout2([Payout-2(EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "aepsPayout",
          name: "aepsPayout([AEPS PAYOUT(PAYSPRINT)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "upiPaymentPayout2",
          name: "upiPaymentPayout2([UPI PAYMENT PAYOUT-2(EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "dmt",
          name: "dmt([DMT (EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "dmt1",
          name: "dmt1([DMT-1 (ISERVEU)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "dmt2",
          name: "dmt2([DMT-2 (PAYSPRINT)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "ppiDmt",
          name: "ppiDmt([PPI DMT (PAYSPRINT)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "aeps",
          name: "aeps([AEPS (EKO)])",
          element: <AEPSHome />,
        },
        {
          path: "aeps1",
          name: "aeps1([AEPS-1 (ISERVEU)])",
          element: <AEPSHome />,
        },
        {
          path: "aeps2",
          name: "aeps2([AEPS-2 (CREDOPAY)])",
          element: <AEPSHome />,
        },
        {
          path: "aeps3",
          name: "aeps3([AEPS-3 (PAYSPRINT)])",
          element: <AEPSHome />,
        },
        {
          path: "e-collection",
          name: "e-collection([DYNAMIC QR (EKO)])",
          element: <ECollection />,
        },
      ]
    },
    // Reports
    {
      path: "reports",
      key: 5.13,
      children: [
        {
          path: "ledgerReport",
          name: "reports-ledgerReport",
          element: <LedgerReport />,
        },
        {
          path: "mainWalletLedgerReport",
          name: "reports-mainWalletLedgerReport",
          element: <MainWalletLedgerReport />,
        },
        {
          path: "pgLedgerReport",
          name: "reports-pgLedgerReport",
          element: <PGLedgerReportRetailer />,
        },
        {
          path: "cashoutReport",
          name: "reports-cashoutReport",
          element: <CashoutReport />,
        },
        {
          path: "aepsLedgerReport",
          name: "reports-aepsLedgerReport",
          element: <AEPSLedgerReport />,
        },
        {
          path: "moneyTransferReports",
          name: "reports-moneyTransferReports",
          element: <MoneyTransferReports />,
        },
        {
          path: "moneyTransferHoldReports",
          name: "reports-moneyTransferHoldReports",
          element: <MoneyTransferHoldReport />,
        },
        {
          path: "aepsTransactionReports",
          name: "reports-aepsTransactionReports",
          element: <AEPSTransactionReports />,
        },
        {
          path: "billPaymentReports",
          name: "reports-billPaymentReports",
          element: <BillPaymentReport />,
        },
        {
          path: "railBookingReports",
          name: "reports-railBookingReports",
          element: <RailBookingReport />,
        },
        {
          path: "flightBookingReports",
          name: "reports-flightBookingReports",
          element: <FlightBookingReport />,
        },
        {
          path: "paymentGetwayReports",
          name: "reports-paymentGetwayReports",
          element: <PaymentGetwayReport />,
        },
        {
          path: "outStandingReports",
          name: "reports-outStandingReports",
          element: <OutStandingReport />,
        },
        {
          path: "topUpReports",
          name: "reports-topUpReports",
          element: <TopUpReports />,
        },
        {
          path: "pgSettlementReports",
          name: "reports-pgSettlementReports",
          element: <PGSettlementReport />,
        },
        {
          path: "pgPayoutReconciliationReports",
          name: "reports-pgPayoutReconciliationReports",
          element: <PGPayoutReconciliationReport />,
        },
        {
          path: "transactionStatusReports",
          name: "reports-transactionStatusReports",
          element: <TransactionStatusReports />,
        },
      ]
    },
  ],
};

export default retailerRouter;
